import React from 'react';


export default class Gluteos extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;

    return(
      <div>
        <strong>Por que não isolar glúteos e treinar pernas no mesmo dia?</strong><br /><br />
        Tentar Isolar Glúteos - Nunca Mais<br /><br />
        Treinar tentando isolar glúteos significa treinar tudo todo dia, e não deixar seus músculos descansarem pra desenvolver. Quando elaboro um treino de “pernas”, seguimos a ciência do treinamento, e faço de 5 a 8 exercícios que englobem coxas e glúteos. Priorizamos os multiarticulares, pois além de potencializar a funcionalidade do corpo, são mais efetivos para todos os músculos envolvidos. Agachamento, hack machine e leg press – esses exercícios, em todas as suas variações, utilizam<br /><br /> essencialmente os quadríceps (anterior de coxa), os bíceps femurais (posterior de coxa), os glúteos (bumbum) e os adutores (interno de coxas). Por isso, não faz sentido separar os treinos de pernas, a menos que você treine só cadeira extensora para quadríceps, só flexora para posterior e só abdutora e caneleiras para glúteo (se fizer isso seu resultado será um fiasco). O que fazem na maioria das academias é dizer que agachamento assim é para quadríceps e assado é para glúteo, mas isso não é verdade.<br /><br />
        Exemplos:<br /><br />
        Agachamento livre, com barra na frente ou nas costas: embora trabalhe todas as musculaturas citadas, parece ter um torque maior em quadríceps e glúteos. Terra/Meio<br /><br />
        Terra/Stiff: igualmente trabalham todas as musculaturas, aumentando o torque nos glúteos e posteriores quando se deixa a perna mais estendida (stiff avançado).<br /><br />
        Leg Press aberto/médio/alto/baixo: independente de qual seja a opção, todas as musculaturas (quadriceps, adutores, posterior e glúteos) são trabalhadas praticamente no mesmo torque, embora possamos usar as posições como efeito de variação.<br /><br />
        Recuo – Avanço – Passada - Afundo: Esses formatos unilaterais de agachamento (agachar com uma perna) são particularmente interessantes e, embora trabalhem tão intensamente as musculaturas citadas, também geram um torque maior nos glúteos, adutores, abdutores e posterior, por causa da modificação do centro de massa (centralização do equilíbrio). Mas quando usamos esse exercício tão importante, estamos treinando fortemente o quadríceps (anterior de coxa).<br /><br />
        Esqueçam os Mitos! A ciência é a coisa mais razoável a que se pode apoiar em se tratando de exercícios e seus resultados.<br /><br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Gluteos.js